


























import Vue from "vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputText: iwInputText,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.epc.reportReference", // TO CHANGE WITH CORRECT PATH
            inputName: "reference-number-epc-report",
            specificId: uuidv4() as string
        };
    },
    computed: {
        referenceNumberReport: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT", "GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            if (value == null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: value});
            }
        }
    }

});
